import { render, staticRenderFns } from "./EditSelectedDigiBoard.vue?vue&type=template&id=7ac1854c&scoped=true"
import script from "./EditSelectedDigiBoard.vue?vue&type=script&lang=js"
export * from "./EditSelectedDigiBoard.vue?vue&type=script&lang=js"
import style0 from "./EditSelectedDigiBoard.vue?vue&type=style&index=0&id=7ac1854c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac1854c",
  null
  
)

export default component.exports